import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Incident, IncidentUpdateState } from 'src/app/models/incident';
import { incidentStatus } from 'src/app/models/transforms';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-reopen-dialog',
  templateUrl: './reopen-dialog.component.html',
  styleUrls: ['./reopen-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, AngularSvgIconModule, MatButtonModule, TranslatePipe],
})
export class ReopenDialogComponent {
  dialogState: IncidentUpdateState = IncidentUpdateState.Open;
  incidentStatus: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Incident) {
    this.incidentStatus = incidentStatus(this.data.incidentType, this.data.isAcknowledged).value;
  }
}
